<template lang="pug">
  nt-dialog(
    v-model='dialog' 
  ) 
    template(#title)
      h3 {{ $t('title.withdraw-commission') }}
      b.red--text {{ $t('minimum-withdraw') }} {{ min_commission_amount }} {{ $t('unit.baht') }}  
    v-card-text 
      v-row.py-5
        v-col(cols=12)
          v-row(no-gutters)
            v-col
              h3 {{ $t('your-income') }}
            v-col(align="end")
              h2 {{ commission_exchange_remain | currency }}
      v-row(justify="center")
        v-col(
          v-for='item in selectTabAmount'
          :key='item'
          cols="auto"
          align="center"
        )
          v-btn-toggle(
            v-model='selectAmount'
            color="var(--bg-secondary-color)"
            class="white--text"
          )
            v-btn.force-round(
              large
              :value='item'
              @click="GA('SelectAmount',item)"
            ) {{ item }}
        v-col(cols=12)
          h4 {{ $t('fill-amount') }}
          n-number-field-specific.mt-2(
            v-model='selectAmount'
            prevent-paste
            :placeholder="$t('placeholder.fill-amount')"
            :suffix="$t('unit.baht')"
            :error-messages='selectAmounterrors'
          )
    v-card-actions
      v-spacer
      v-btn(
        color='grey-light-7'
        depressed
        @click='cancelDialog'
      ) {{ $t('button.cancel') }}
      v-btn.white--text(
        color='var(--bg-secondary-color)'
        depressed
        :disabled='submitStatus'
        :loading='submitStatus'
        @click='withdrawOrder'
      ) {{ $t('button.withdraw') }}

</template>
<script> 
import { credits as apiCredits } from '@/apis'   
import { validationMixin } from 'vuelidate'
import { required} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  validations:{
    selectAmount:{required}, 
  }, 
  data () {
    return {  
      dialog:false,  
      selectAmount:null,
      selectTabAmount:['200','500','1000','1500','3000'],   
      submitStatus:false,
      commission_exchange_remain:null,
    }
  },
  computed : {
    selectAmounterrors (){
      const errors = []
      if (!this.$v.selectAmount.$dirty) return errors
      !this.$v.selectAmount.required && errors.push(this.$t('valdiate.please-enter-number'))
      if(parseInt(this.commission_exchange_remain)-parseInt(this.selectAmount)<0)
      { 
      errors.push(this.$t('validate.money-not-enough')) 
      return errors
      }
      if(parseInt(this.selectAmount)<this.min_commission_amount){ 
      errors.push(`${this.$t('validate.minimum-amount-can-withdraw-is')} ${this.min_commission_amount} ${this.$t('unit.baht')}`) 
      return errors
      } 
      if(parseInt(this.selectAmount)>this.max_commission_amount){ 
      errors.push(`${this.$t('validate.maximum-amount-can-withdraw-is')} ${this.max_commission_amount} ${this.$t('unit.baht')}`) 
      return errors
      } 
      return errors 
    },
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
    min_commission_amount () {
      return (this.userProfile.credit_request_condition || {}).min_commission_amount || 0
    },
    max_commission_amount () {
      return (this.userProfile.credit_request_condition || {}).max_commission_amount || 0
    }
  },
  methods : { 
    GA (actions,value) {
      this.$ga.event('Button', actions, 'AffiliatePage',value )
    }, 
    async withdrawOrder (){
      this.submitStatus=true
      this.$ga.event('Button', 'Withdraw', 'AffiliatePage','' )
      this.$v.selectAmount.$touch()

      if(!this.$v.selectAmount.$invalid
      &&parseFloat(this.commission_exchange_remain)-parseFloat(this.selectAmount)>=0
      &&parseFloat(this.selectAmount)>=this.min_commission_amount
      &&parseFloat(this.selectAmount)<=this.max_commission_amount
      ){ 

        let params = {
            request_amount : this.selectAmount
        }  

        const [err,data] = await apiCredits.withdrawCommission(params)

        if(err) {
          this.$alert('',err,'warning')  
          return
        }

 
        this.$alert('',data.message,'success')
        this.selectAmount = null
        this.$store.dispatch('userProfile/ACTION_WALLET') 
        this.$emit('success') 
          
        this.dialog = false 
      } 
      
      this.submitStatus=false 
    }, 
    closeDialog () {
      this.$ga.event('Button', 'CloseWithdrawDialog', 'AffiliatePage','' )
      this.dialog=false
    }, 

    cancelDialog () {
      this.$ga.event('Button', 'CancelWithdrawDialog', 'AffiliatePage','' )
      this.dialog=false
    },  

    open (value) {
      this.commission_exchange_remain = value
      this.dialog = true
      this.selectAmount = null
    }
  }
}
</script>